"use client";

import type { Usable } from "react";
import Form from "next/form";
import type { ResolvedIntlConfig } from "react-intl";
import { SlMagnifier } from "react-icons/sl";
import { Button } from "@repo/components/atoms/shadcn/button";
import { cn } from "@repo/lib";
import { useSearchParams } from "next/navigation";
import { useGetIntl } from "@repo/i18n/intl/client";

export function SidebarSearch({
  className,
  dictionaryPromise,
  lang,
  sidebarId,
}: {
  className?: string;
  dictionaryPromise: Usable<ResolvedIntlConfig["messages"]>;
  lang: Navigator["language"];
  sidebarId: string;
}) {
  const intl = useGetIntl({
    dictionaryPromise,
    lang,
  });

  const searchParams = useSearchParams();

  return (
    <Form
      action="/search"
      className={cn("grid relative items-center", className)}
    >
      <h2 className="mb-2 text-lg uppercase">
        {intl.formatMessage({
          defaultMessage: "Search the store",
          id: "6tEVX+",
          description: "Prompt for the user to carry out a search",
        })}
      </h2>
      <div className="grid grid-flow-col grid-cols-[1fr_auto] gap-1">
        <input
          autoComplete="on"
          defaultValue={searchParams?.get("query") || undefined}
          name="search"
          placeholder={intl.formatMessage({
            defaultMessage: "Search the site",
            id: "7z91CD",
            description:
              "placeholder attribute for a search input in the GlobalSidebarSearch component",
          })}
          type="search"
        />
        <Button
          aria-label={intl.formatMessage({
            defaultMessage: "Search the store",
            id: "6tEVX+",
            description: "Prompt for the user to carry out a search",
          })}
          className="h-full rounded-none"
          popoverTarget={sidebarId}
          popoverTargetAction="hide"
          variant="secondary"
        >
          <SlMagnifier className="icon fill icon-size" />
        </Button>
      </div>
    </Form>
  );
}
